{
  "selectAsField": "Wybierz \"{value}\" jako {fieldName}",
  "typeToSearchField": "Wpisz, aby wyszukać {fieldName}",
  "licenseFieldLabel": "Wybierz numer rejestracyjny (np. 215BG2)",
  "licenseFieldName": "Numer rejestracyjny",
  "licensePlaceholder": "Szukaj według numeru rejestracyjnego",
  "dotFieldLabel": "Wybierz numer DOT",
  "dotFieldName": "Numer DOT",
  "dotPlaceholder": "Szukaj według numeru DOT",
  "chooseOneOption": "Wybierz jedną z poniższych opcji"
}
